import { Heading, Stack, Text } from '@chakra-ui/react'

import FirestoreUser from '../../../../types/FirestoreUser'
import { ProfileBadges } from './ProfileBadges'

interface Props {
  user: FirestoreUser
  profile: FirestoreUser['profile'] | undefined
}

export function UserHeader({ user, profile }: Props) {
  return (
    <Stack spacing={0}>
      <Heading>
        {profile ? `${profile.firstName} ${profile.lastName}` : 'No Profile'}
      </Heading>
      <ProfileBadges
        profile={profile}
        additionalDetails={user.additionalDetails}
        medicalDetails={user.medicalDetails}
      />
      <Text>#{user.patientId}</Text>
    </Stack>
  )
}
